interface ComputerWithBoxAndPencilsSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithBoxAndPencilsSVG = ({
  color,
  style,
}: ComputerWithBoxAndPencilsSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="43"
    viewBox="0 0 53 43"
    fill="none"
  >
    <path
      d="M32.9406 41.8638V34.689H19.6431V41.8607"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0403 41.8638H40.2445"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.61998 1.13617C2.3289 1.13617 1.28418 2.18577 1.28418 3.48289V32.3422C1.28418 33.6393 2.3289 34.6889 3.61998 34.6889H48.6644C49.9555 34.6889 51.0002 33.6393 51.0002 32.3422V3.48289C51.0002 2.18577 49.9555 1.13617 46.865 1.13617H3.61998Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.2793 27.6112L17.4663 23.7105V12.4186L26.2793 16.3194V27.6112Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.2793 27.6112L35.0892 23.7105V12.4186L26.2793 16.3194"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.0893 12.4186L26.2793 8.51788L17.4663 12.4186"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.0892 23.7105L33.7327 23.1089"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.6994 22.2097L28.6526 20.8624"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.6359 20.4113L26.2794 19.8098L24.9197 20.4113"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.8864 21.3105L19.8396 22.6609"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.826 23.1089L17.4663 23.7105"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.2793 8.51788V16.3194"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.7473 15.3136L37.3689 18.5219L39.0155 20.1762L45.5457 17.3407L46.893 13.5246L43.9896 10.6076L40.1912 11.958L39.2244 14.2076"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.1995 13.5841C42.658 13.1236 43.4033 13.1236 43.8648 13.5841C44.3233 14.0447 44.3233 14.7935 43.8648 15.2572C43.4064 15.7178 42.6611 15.7178 42.1995 15.2572C41.7411 14.7967 41.7411 14.0478 42.1995 13.5841Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.2109 19.3648L42.2682 15.2886"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.1663 11.8515L46.8929 13.5246L43.9895 10.6076L45.6954 8.36432"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0062 18.6739L13.4341 16.2347L7.68305 10.4568L5.25518 12.896L11.0062 18.6739Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4338 16.2379L15.0835 20.3329L11.0076 18.6786"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.68309 10.4573L6.2548 9.02231C5.84626 8.61187 5.18201 8.61187 4.77036 9.02231L3.82544 9.97165C3.41691 10.3821 3.41691 11.0494 3.82544 11.463L5.25374 12.898"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.459 10.8051V5.17169H19.0693"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.2148 5.17169H38.8251V10.8051"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.8251 25.017V30.6535H33.2148"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.0693 30.6535H13.459V25.017"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ComputerWithBoxAndPencilsSVG;
